import React, { useEffect, useMemo, useState } from "react";
import { subscribeEmployees } from "../../lib/employeesApi";
import { subscribeCategories } from "../../lib/servicesApi";
import EmployeeDetailsModal from "../../Employee/EmployeeDetailsModal";

const decode = (s) => String(s || "");

export default function EmployeesList() {
  const [approved, setApproved] = useState([]);
  const [error, setError] = useState(null);
  const [cats, setCats] = useState([]);
  const [search, setSearch] = useState("");
  const [showDetail, setShowDetail] = useState(null);

  useEffect(
    () => subscribeEmployees(setApproved, setError, { status: "approved" }),
    []
  );
  useEffect(() => subscribeCategories(setCats, () => {}), []);

  const filteredApproved = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return approved;
    return approved.filter((e) => {
      const name = `${e.firstName || ""} ${e.lastName || ""}`.toLowerCase();
      const addr = (e.address || "").toLowerCase();
      const mobile = (e.mobile || "").toLowerCase();
      const aadhaar = (e.aadhaar || "").toLowerCase();
      return (
        name.includes(q) ||
        addr.includes(q) ||
        mobile.includes(q) ||
        aadhaar.includes(q)
      );
    });
  }, [approved, search]);

  const grouped = useMemo(() => {
    const map = new Map();
    filteredApproved.forEach((e) => {
      const key = e.categoryKey || "uncategorized";
      const arr = map.get(key) || [];
      arr.push(e);
      map.set(key, arr);
    });
    return map;
  }, [filteredApproved]);

  const catLabel = (key) =>
    decode(cats.find((c) => c.key === key)?.label || key || "Uncategorized");

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
        <h5 className="mb-0">Approved Employees ({approved.length})</h5>
        <input
          className="form-control form-control-sm"
          style={{ maxWidth: 260 }}
          placeholder="Search name / location / mobile / Aadhaar"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      {error && <div className="alert alert-danger">{error.message}</div>}

      {[...grouped.entries()].map(([key, arr]) => (
        <div className="card shadow-sm mb-3" key={key}>
          <div className="card-body">
            <h6 className="mb-2">
              {catLabel(key)} — {arr.length} employees
            </h6>
            <div className="table-responsive">
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Aadhaar</th>
                    <th>Age</th>
                    <th>Experience</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {arr.map((e) => (
                    <tr
                      key={e.id}
                      onClick={() => setShowDetail(e)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>{e.empId}</td>
                      <td>{`${e.firstName || ""} ${e.lastName || ""}`}</td>
                      <td>{e.mobile || "-"}</td>
                      <td>{e.aadhaar || "-"}</td>
                      <td>{e.ageYears ?? "-"}</td>
                      <td>{e.experienceYears ?? "-"}</td>
                      <td>
                        <span
                          className={`badge ${
                            e.status === "approved"
                              ? "bg-success"
                              : e.status === "pending"
                              ? "bg-warning"
                              : "bg-danger"
                          }`}
                        >
                          {e.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="small text-muted">
              <em>Tip:</em> click a row to view full profile & all jobs.
            </div>
          </div>
        </div>
      ))}

      {!error && approved.length === 0 && (
        <div className="alert alert-info">No approved employees yet.</div>
      )}

      <EmployeeDetailsModal
        show={!!showDetail}
        onClose={() => setShowDetail(null)}
        employee={showDetail}
      />
    </>
  );
}
